import { render, staticRenderFns } from "./CollectivesTrash.vue?vue&type=template&id=26f209f0&scoped=true"
import script from "./CollectivesTrash.vue?vue&type=script&lang=js"
export * from "./CollectivesTrash.vue?vue&type=script&lang=js"
import style0 from "./CollectivesTrash.vue?vue&type=style&index=0&id=26f209f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f209f0",
  null
  
)

export default component.exports